<div class="form-group">
    <label for="name">Customer name</label>
    <input class="form-control" type="text" [(ngModel)]="customer.name" placeholder="Customer Name" name="name" id="name" />
</div>
